
import React from 'react';
const ArrowLeftRight = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6635_140648)">
      <path d="M3.12109 10.8713L0.999773 8.75001L3.12109 6.62869" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.00085 8.75L6.72571 8.75" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.82812 1.24112L10.9494 3.36244L8.82812 5.48376" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.9484 3.36246L5.22351 3.36245" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6635_140648">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);


export default ArrowLeftRight;
